import { MainContentFirma } from '../../components/signer/MainContentFirma';

export const SignerPage = ({ setFileName }) => {
    return (
        <main className="main-content main-full">
            <MainContentFirma setFileName={setFileName}/>
        </main>
    );
}